<!-- エラー画面 -->
<template>
  <div id="wrapper1">
    <img
      src="@/assets/common/img/with-kaunet_logo-errorpage.png"
      alt="ウィズカウネット エージェントポータル"
      class="with-kaunet_logo-overtime"
    />

    <h2 class="com_mgb20 com_mgt100 com_fs26 com_medium1 com_center1">
      予期しないエラーが発生しました。
    </h2>

    <p class="com_mgb50 com_reguler1 com_center1">
      大変恐れ入りますが再度同じ手順を行って頂き、それでも正しく動作しない場合は<br />
      担当営業もしくはカウネットにお問い合わせください
    </p>

    <p class="com_copyright1 com_mgt100">© 2025 Kaunet</p>
  </div>
</template>
<script>
export default {
  name: "AboutComponent",
};
</script>
